/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

module.exports = '15.6.2';


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/lib/ReactVersion.js
 ** module id = 1295
 ** module chunks = 0
 **/